import { FileAddOutlined } from '@ant-design/icons'
import { Suspense, useState } from 'react'

import { safeLazy } from '@/utils/app/safeLazy'

const ContractCreationModal = safeLazy(
  () =>
    import(
      '@/components/EntityCreationModals/ContractCreationModal/ContractCreationModal'
    )
)

let preloadPromise: Promise<
  typeof import('@/components/EntityCreationModals/ContractCreationModal/ContractCreationModal')
> | null = null
function preloadModal() {
  if (!preloadPromise) {
    preloadPromise = import(
      '@/components/EntityCreationModals/ContractCreationModal/ContractCreationModal'
    )
  }
  return preloadPromise
}

type ContractCreationButtonProps = {
  className: string
  onCreated: () => void
}

function ContractCreationButton({
  className,
  onCreated,
}: ContractCreationButtonProps) {
  const [open, setOpen] = useState(false)

  const handleOpenModal = async () => {
    await preloadModal()
    setOpen(true)
  }

  return (
    <>
      <div className={className}>
        <button onClick={handleOpenModal} onMouseEnter={preloadModal}>
          <div>
            <FileAddOutlined />
          </div>
          Создать договор
        </button>
      </div>
      {open && (
        <Suspense fallback={null}>
          <ContractCreationModal
            open={open}
            setOpen={setOpen}
            onContractCreated={onCreated}
          />
        </Suspense>
      )}
    </>
  )
}

export default ContractCreationButton
